<template lang='pug'>
.publicArticles
  SectionTitle(:sectionText='staticData.publicArticle.title')
  Search(@search="search" @sortByType="sortByType" :staticData='staticData' :userType="userType" :sortType="sortConfig.defaultSortType" :sortConfig="sortConfig")
  table.tableTop10
    TableGovHead(@sortByType="sortByType" :type="userType")
    TableGovBody(:infos="infos" :type="userType")
  TableBodyNoArticle(v-if="(!infos || infos.length == 0)" text="查無資料，請嘗試其他關鍵字或篩選條件。" :isLoading="isLoading")
  div(v-if="infos && infos.length > 0")
    Pagination(:pageCount='totalPages' @changePage='changePage' :currentPage='localParams.page + 1')
</template>

<script>
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import Search from '@/components/modules/search/search.vue'
import TableGovHead from '@/components/modules/table_gov/table_gov_head.vue'
import TableGovBody from '@/components/modules/table_gov/table_gov_body.vue'
import TableBodyNoArticle from '@/components/modules/table_list/table_body_no_article.vue'
import Pagination from '@/components/modules/pagination/pagination.vue'
import { getParams, changeStyle, getDate, getRouteByParam, initLocalParamByQueryStr } from '@/plugins/tool.js'

export default {
  props: {
    staticData: Object
  },
  created() {
    this.localParams = JSON.parse(JSON.stringify(this.params))
    this.localParams = initLocalParamByQueryStr(this.$route.query, this.localParams)
    this.getInfo()
  },
  data() {
    return {
      params: {
        "size": 12,
        "page": 0,
        "sort": {
          "updatedAt": {
            "dir": "desc",
            "default": true
          }
        }
      },
      localParams: {},
      infos: [],
      totalPages: 0,
      isLoading: false,
      userType: localStorage.getItem(this.$store.state.storageKeys.identity),
      sortConfig: {
        "type": "partners",
        "defaultSortType": "updatedAt-1"
      },
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  components: {
    SectionTitle,
    Search,
    TableGovHead,
    TableGovBody,
    TableBodyNoArticle,
    Pagination
  },
  methods: {
    async getInfo() {
      this.isLoading = true
      let route = (this.identity === "government"
          ? this.$store.state.URLs.apiPartner
          : this.$store.state.URLs.api) +
        "/" +
        this.$store.state.lang + 
        this.$store.state.routes.govAnnounces

      route = getRouteByParam(this.localParams, route)
      
      const token = localStorage.getItem(this.$store.state.storageKeys.token);
      const headers = token ? { 'X-Line-Biz-Session': token } : {};

      this.$axios.get(route, {headers})
      .then(result => {
        this.isLoading = false
        this.totalPages = result.data.totalPages
        this.infos = Object.values(result.data.content)

        this.infos.forEach(info => {
          let date = getDate(info.updatedAt)
          info.updatedAtStr = date.year + "/" + date.month + "/" + date.date
        })
      })
      .catch(() => {
        this.isLoading = false
      })

    },
    changePage(page) {
      this.localParams.page = page - 1
      this.$router.push({
        "path": this.$route.path,
        "query": {
          "type": this.type,
          "params": JSON.stringify(this.localParams)
        }
      })
    },
    sortByType(sortData) {
      changeStyle(sortData)
      this.localParams = getParams(this.localParams, sortData)
      this.getInfo()
    },
    search(keyword, start, end, govId, partnerId, categoryId) {
      this.localParams["page"] = 0
      this.params["page"] = 0
      this.localParams["keyword"] = keyword
      this.params["keyword"] = keyword
      if (govId != null) {
        this.localParams["govOptionId"] = govId
        this.params["govOptionId"] = govId
      } else {
        delete this.localParams.govOptionId
        delete this.params.govOptionId
      }
      if (start) {
        this.localParams["startDate"] = start.toISOString()
        this.params["startDate"] = start.toISOString()
      }
      else {
        delete this.localParams.startDate
        delete this.params.startDate
      }
      if (end) {
        this.localParams["endDate"] = end.toISOString()
        this.params["endDate"] = end.toISOString()
      }
      else {
        delete this.localParams.endDate
        delete this.params.startDate
      }
      if (partnerId) {
        this.localParams["partnerId"] = partnerId
        this.params["partnerId"] = partnerId
      }
      else {
        delete this.localParams.partnerId
        delete this.params.partnerId
      }
      if (categoryId) {
        this.localParams["categoryId"] = categoryId
        this.params["categoryId"] = categoryId
      }
      this.getInfo()
    }
  }
}
</script>
